export default __webpack_public_path__ + "static/media/cutlery-icon.dd16c2d2.svg";